import React from 'react';

import { withTranslation } from 'react-i18next';

import LinkItem from './linkitem';

class RelatedLinks extends React.Component {

  render() {
    const { t, links } = this.props;
    let l = 0;
    let items = [];
    if (links) {
      l = links.length;
      items = links.map(item => {
        return (
          <LinkItem link={item.link} title={item.title} text={item.text} key={item.link} />
        )
      })
    }

    return (
      <>
      {l > 0 ? 
      <div>
        <h4>{t("Blog.relatedlinks._headline")}</h4>
        <ul className="list-group">
          {items}
        </ul>
      </div>
      : null }
      </>
    )
  }
}

RelatedLinks.defaultProps = {
  links: []
}

export default withTranslation()(RelatedLinks);